import { Component, Input } from '@angular/core';
import { ResultSummaryDto } from '@shared/clients/api.generated';

@Component({
  selector: 'valg-dk-result-summary',
  templateUrl: './result-summary.component.html'
})
export class ResultSummaryComponent {
  @Input() resultSummary?: ResultSummaryDto; 

  isShown(): boolean {
    return this.resultSummary !== undefined &&
      this.resultSummary?.finalResults !== this.resultSummary?.pollingAreasCount && (
      this.resultSummary?.preliminaryResults !== 0 || 
      this.resultSummary?.finalResults !== 0)
  }
}
